import { cn } from "@/shared/libs/commonUtils";
import { HTMLAttributes } from "react";

interface BoxProps extends HTMLAttributes<HTMLDivElement> {}

export default function Box({ children, className, ...props }: BoxProps) {
  return (
    <div className={cn(className, "relative")} {...props}>
      {children}
    </div>
  );
}
